export default __webpack_public_path__ + "static/media/picture_of_woman.9f608527.png";